import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TenantWebhook = React.lazy(() =>
    import('../TenantWebhook')
);
const tenantWebhookRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_WEBHOOK_PAGE,
        element: <TenantWebhook />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantWebhookRoutesRegistry;

